import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";
import { GoldMark } from "@/components/common";

export function BrandMarquee() {
  const { t } = useLang();
  const items = t("marquee.items").split("•").map((s) => s.trim()).filter(Boolean);
  return (
    <div className="relative border-y border-white/[0.06] bg-panel/60 py-5" data-testid="brand-marquee">
      <Marquee speed={38} gradient={false} pauseOnHover>
        {items.concat(items).map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-display text-2xl uppercase tracking-wide text-white/[0.14] transition-colors hover:text-gold/60">
              {item}
            </span>
            <GoldMark size={16} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
